export default __webpack_public_path__ + "static/media/IMG-20260729-WA0000.jpg.afd2a66a.jpeg";